<div class="login-shell">
  <div class="login-card">
    <p class="eyebrow">The {{ appName }}</p>
    <h1 class="title">{{ appShortName }}</h1>
    <p class="subtitle">
      A mobile-first workspace for financing groups funding overseas assets.
    </p>

    <button (click)="login()" class="login-button">
      Continue with secure sign-in
    </button>
  </div>
</div>
